/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const handlePhoneRegister = async (event) => {
    event.preventDefault();

    const errorElement = document.querySelector('.phone-register-error-banner.hidden');
    const errorClass = '.phone-register-error-banner';
    if (!errorElement) {
        hideError(errorClass);
    }

    const phoneNumber = document.getElementById('PhoneRegisterForm-Phone').value;

    toggleLoadingBtn('phone-register');
    grecaptcha.ready(async () => {
        try {
            const captchaToken = await grecaptcha.execute('6LfQlyAqAAAAAEoCCRS81zjJuBwkoBNghyXp4_kA', { action: 'OTP_SEND' });
            const response = await fetch(`${PROXY}/otp/send`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phoneNumber, uuid: sessionStorage.getItem('otp-uuid'), captchaToken }),
            });

            if (!response.ok) {
                throw new Error('somethingWrong');
            }
            const jsonResponse = await response.json();

            if (!jsonResponse.success) {
                throw new Error('somethingWrong');
            }

            openOtpLoginPopup(null, 'otp-code');
            document.querySelector('#phoneNumberId').textContent = jsonResponse.phone;
            closeOtpLoginPopup('phone-register', true);
        } catch (error) {
            showError(errorClass, 'somethingWrong');
        } finally {
            toggleLoadingBtn('verify-customer-id');
        }
    });
};
